(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambra-bogo-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Wspolny rejestr instancji BOGO (klucz = section id). Ten bundle laduje sie RAZ,
     wiec sami inicjalizujemy KAZDY [data-bogo-bar] na stronie (multi-instance safe).
     Osobny namespace __asbBogo -> koegzystuje z sekcja progresu (__asbProg). */
  var NS = window.__asbBogo = window.__asbBogo || {
    instances: {},
    docBound: false,
    fetchPatched: false,
    modalOverlay: null,
    currentTrigger: null,
    saleCache: {},
    salePending: {}
  };
  /* Cache przecen wspoldzielony przez wszystkie instancje BOGO na stronie
     (klucz = uchwyt produktu -> mapa variantId => onSale). */
  if (!NS.saleCache) NS.saleCache = {};
  if (!NS.salePending) NS.salePending = {};
  var isDesignMode = window.Shopify && window.Shopify.designMode;

  /* ============ RELOKACJA do sticky headera ============ */
  function relocate(sectionId) {
    if (isDesignMode) return;
    var section = document.getElementById('shopify-section-' + sectionId);
    var headerWrapper = document.querySelector('.header-section--wrapper');
    if (!section || !headerWrapper) return;
    if (section.parentElement === headerWrapper) return;
    headerWrapper.insertBefore(section, headerWrapper.firstChild);
  }

  /* ============ ROTATOR komunikatow ============ */
  function initRotator(root, inst) {
    var rotator = root.querySelector('[data-promo-rotator]');
    if (!rotator) return;
    if (rotator.dataset.rotatorInit === 'true') return;
    rotator.dataset.rotatorInit = 'true';
    var messages = rotator.querySelectorAll('.ppromo__message');
    if (messages.length < 2) return;
    inst.rotMessages = messages;
    inst.rotCurrent = 0;
    inst.rotInterval = parseInt(rotator.dataset.interval, 10) || 5000;
    inst.rotReduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (inst.rotReduced) return; /* A3: nie startuj przy reduced-motion */
    startRotator(inst);
  }
  function startRotator(inst) {
    if (!inst || inst.rotReduced) return;
    if (!inst.rotMessages || inst.rotTimer) return;
    if (document.hidden) return; /* A3: nie startuj gdy karta ukryta */
    inst.rotTimer = setInterval(function () {
      inst.rotMessages[inst.rotCurrent].classList.remove('ppromo__message--active');
      inst.rotCurrent = (inst.rotCurrent + 1) % inst.rotMessages.length;
      inst.rotMessages[inst.rotCurrent].classList.add('ppromo__message--active');
    }, inst.rotInterval);
  }
  function stopRotator(inst) {
    if (inst && inst.rotTimer) { clearInterval(inst.rotTimer); inst.rotTimer = null; }
  }

  /* ============ Wykrywanie mutacji koszyka (wspolne) ============ */
  function isCartMutation(url, method) {
    var m = String(method || 'GET').toUpperCase();
    return /\/cart(\/|\?|$|\.js)/i.test(url) && !(m === 'GET' && /\/cart\.js(\?|$)/i.test(url));
  }
  function refreshAll() {
    var ins = NS.instances;
    for (var id in ins) {
      if (ins.hasOwnProperty(id) && ins[id].refresh) ins[id].refresh();
    }
  }
  /* A1: MINIMALNY, opcjonalny wrapper TYLKO na fetch (bez XHR), instalowany raz. */
  function installFetchFallback() {
    if (NS.fetchPatched || !window.fetch) return;
    NS.fetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = ''; var method = 'GET';
      try {
        if (typeof args[0] === 'string') url = args[0];
        else if (args[0]) { url = args[0].url || String(args[0]); method = args[0].method || 'GET'; }
        if (args[1] && args[1].method) method = args[1].method;
      } catch (e) {}
      var p = origFetch.apply(this, args);
      if (isCartMutation(url, method)) {
        p.then(function () { refreshAll(); }).catch(function () {});
      }
      return p;
    };
  }

  /* ============ SILNIK v2 - czyste funkcje (lustro Liquid; eksport NS.* do testow) ============ */
  var SYMBOLS = ['x', 'od', 'do', 'nr_nagrody', 'co', 'brakuje', 'nagroda', 'nagroda_krotko', 'ile_nagrod', 'wariant', 'produkty', 'n'];

  function csvList(s) {
    return String(s == null ? '' : s).split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
  }
  function matchesAny(h, list) {
    h = (h || '').toLowerCase();
    for (var i = 0; i < list.length; i++) { if (list[i] && h.indexOf(list[i]) !== -1) return true; }
    return false;
  }
  function variantHay(item) {
    var h = (item.variant_title || '');
    if (item.options_with_values) { for (var i = 0; i < item.options_with_values.length; i++) { h += ' ' + item.options_with_values[i].value; } }
    return h.toLowerCase();
  }
  function variantMatches(item, list) {
    if (!list.length) return true;
    var h = variantHay(item);
    for (var j = 0; j < list.length; j++) { if (list[j] && h.indexOf(list[j]) !== -1) return true; }
    return false;
  }
  /* Jedna stala lista symboli po obu stronach; nieznane {cos} zostaje jak wpisane (tak samo w Liquid). */
  function format(tpl, vars) {
    tpl = tpl == null ? '' : String(tpl);
    for (var i = 0; i < SYMBOLS.length; i++) {
      var k = '{' + SYMBOLS[i] + '}';
      if (tpl.indexOf(k) !== -1) tpl = tpl.split(k).join(vars[SYMBOLS[i]] != null ? String(vars[SYMBOLS[i]]) : '');
    }
    return tpl;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /* Liczenie koszyka: X = sztuki zakupu, G = sztuki nagrody-wariantu (tylko tryb variant). Bramka przecen NADRZEDNA. */
  function countLines(cfg, cart, isOnSale) {
    var res = { x: 0, g: 0 };
    if (!cart || !Array.isArray(cart.items)) return res;
    var P = csvList(cfg.patterns), V = csvList(cfg.vfilter);
    var giftCheck = (cfg.mode === 'variant' || cfg.mode === 'any_from');
    var GP = giftCheck ? csvList(cfg.giftPatterns) : [], GV = csvList(cfg.giftVfilter);
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (cfg.excludeSale && isOnSale && isOnSale(it)) continue;
      var h = (it.handle || '').toLowerCase();
      if (GP.length && matchesAny(h, GP) && variantMatches(it, GV)) { res.g += it.quantity || 0; if (cfg.mode === 'variant') continue; }
      if (!matchesAny(h, P)) continue;
      if (!variantMatches(it, V)) continue;
      res.x += it.quantity || 0;
    }
    return res;
  }
  /* compute(X, G): identyczne galezie jak w Liquid. */
  function compute(cfg, x, g) {
    var B = parseInt(cfg.buy, 10) || 4, M = !!cfg.multi, L = parseInt(cfg.limit, 10) || 0, variant = cfg.mode === 'variant', anyFrom = cfg.mode === 'any_from';
    x = parseInt(x, 10) || 0; g = (variant || anyFrom) ? (parseInt(g, 10) || 0) : 0;
    var gifts = 0, pending = 0, limit = false, items = 0, cycleLen;
    if (variant) {
      cycleLen = B;
      var cyclesRaw = M ? Math.floor(x / B) : (x >= B ? 1 : 0);
      var cycles = (L > 0 && cyclesRaw > L) ? L : cyclesRaw;
      gifts = Math.min(cycles, g);
      pending = cycles - gifts;
      limit = (L > 0 && M && cyclesRaw >= L && pending === 0);
      if (limit || pending > 0) items = B;
      else if (M) items = x % B;
      else items = Math.min(x, B);
    } else {
      cycleLen = B + 1;
      var giftsRaw = M ? Math.floor(x / cycleLen) : (x > B ? 1 : 0);
      var cyc = (L > 0 && giftsRaw > L) ? L : giftsRaw;
      gifts = anyFrom ? Math.min(cyc, g) : cyc;
      pending = cyc - gifts;
      limit = (L > 0 && M && giftsRaw >= L && pending === 0);
      if (limit) items = cycleLen;
      else if (pending > 0) items = B;
      else if (M) items = x % cycleLen;
      else items = x;
    }
    var state;
    if (x === 0 && g === 0) state = 'empty';
    else if (limit) state = 'limit';
    else if (pending > 0) state = 'gift_missing';
    else if (!M && gifts > 0) state = 'success';
    else if (M && items === 0 && gifts > 0) state = 'cycle_complete';
    else if (items < B) state = 'progress';
    else if (items === B) state = 'near';
    else state = 'success';
    var od = M ? gifts * cycleLen + 1 : 1;
    var doN = od + B - 1;
    var nr = doN + 1;
    return { x: x, g: g, buy: B, gifts: gifts, items: items, pending: pending, limit: limit, state: state, od: od, do: doN, nr: variant ? '' : nr, brakuje: Math.max(B - items, 0) };
  }
  function symbolVars(cfg, r) {
    var v = cfg.vars || {};
    return {
      x: r.buy, od: r.od, do: r.do, nr_nagrody: r.nr,
      co: cfg.mode === 'variant' ? (v.wariant || '') : (r.nr + '. szt.'),
      brakuje: r.brakuje, nagroda: v.nagroda || '', nagroda_krotko: v.nagroda_krotko || '',
      ile_nagrod: r.gifts, wariant: v.wariant || '', produkty: v.produkty || '', n: r.items
    };
  }
  /* Etykiety pod pigulkami dla stanu (HTML escapowany; wyroznienie naklada kod, nie tresc). */
  function renderLabels(cfg, r, key) {
    key = key || r.state;
    var t = cfg.tpl || {}, v = symbolVars(cfg, r), buy, get;
    switch (key) {
      case 'progress': case 'cycle_complete': buy = t.progress_buy; get = t.progress_get; break;
      case 'near': buy = t.near_buy; get = ((cfg.mode === 'variant' || cfg.mode === 'any_from') && r.g <= r.gifts) ? t.gift_missing : t.near_get; break;
      case 'gift_missing': buy = t.near_buy; get = t.gift_missing; break;
      case 'success': buy = t.success_buy; get = t.success_get; break;
      case 'limit': buy = t.limit_buy; get = t.limit_get; break;
      case 'just_earned': buy = t.earned_buy; get = t.earned_get; break;
      default:
        var hl = format(t.empty_highlight, v);
        return { state: 'empty', buy: escapeHtml(format(t.empty_buy, v)), get: escapeHtml(format(t.empty_prefix, v)) + (hl ? ' <span class="ppromo__highlight">' + escapeHtml(hl) + '</span>' : '') };
    }
    return { state: key, buy: escapeHtml(format(buy, v)), get: '<span class="ppromo__highlight">' + escapeHtml(format(get, v)) + '</span>' };
  }
  NS.compute = compute; NS.countLines = countLines; NS.renderLabels = renderLabels; NS.format = format; NS.symbolVars = symbolVars;

  /* ============ SILNIK DYNAMICZNY (per instancja) ============ */
  function initDynamic(root, inst) {
    if (root.dataset.runDynamic !== 'true') return;
    if (root.dataset.dynInit === 'true') return;
    root.dataset.dynInit = 'true';

    var cfgEl = root.querySelector('[data-promo-config]');
    var cfg = null;
    try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : null; } catch (e) { cfg = null; }
    if (!cfg) return;
    var BUY_QTY = parseInt(cfg.buy, 10) || 4;
    var MULTIPLICATIVE = !!cfg.multi;
    var PATTERNS = csvList(cfg.patterns);
    var GPATTERNS = (cfg.mode === 'variant' || cfg.mode === 'any_from') ? csvList(cfg.giftPatterns) : [];
    var EXCLUDE_SALE = !!cfg.excludeSale;

    /* /cart.js line items NIE maja compare_at_price, wiec dopasowujemy po variant_id
       wg listy wariantow w przecenie renderowanej server-side (kolekcje + koszyk). */
    var SALE_IDS = {}; (root.dataset.saleVariants || '').split(',').forEach(function (x) { if (x) SALE_IDS[x] = 1; });

    function anyHandleMatches(h) { return matchesAny(h, PATTERNS) || (GPATTERNS.length && matchesAny(h, GPATTERNS)); }

    /* ===== AUTORYTATYWNE rozpoznawanie przecen (per wariant) =====
       SALE_IDS to tylko snapshot z renderu: kolekcje sa w Liquid obciete do 50
       produktow, a pozycja dodana przez AJAX juz po renderze w ogole tam nie trafia.
       Dlatego dla uchwytow objetych paskiem dociagamy rekord produktu RAZ na uchwyt
       i zapamietujemy mape variantId => onSale (pamiec + sessionStorage).
       Do czasu rozwiazania linia jest traktowana jako NIE-przeceniona (liczy sie),
       zeby nie migotal normalny scenariusz; po rozwiazaniu robimy jeden przelicz. */
    var unresolved = false; /* true = jakas linia czeka na /products/x.js - nie renderuj stanu z niepewnych danych */
    var SALE_CACHE = NS.saleCache;
    var SALE_PENDING = NS.salePending;
    var SALE_SS_PREFIX = 'ambraSale:';

    function readSaleMap(handle) {
      if (SALE_CACHE[handle]) return SALE_CACHE[handle];
      try {
        var raw = window.sessionStorage.getItem(SALE_SS_PREFIX + handle);
        if (raw) {
          var parsed = JSON.parse(raw);
          if (parsed && typeof parsed === 'object') {
            SALE_CACHE[handle] = parsed;
            return parsed;
          }
        }
      } catch (e) {}
      return null;
    }

    function writeSaleMap(handle, map) {
      SALE_CACHE[handle] = map;
      try {
        window.sessionStorage.setItem(SALE_SS_PREFIX + handle, JSON.stringify(map));
      } catch (e) {}
    }

    function recountFromLastCart() {
      if (inst.lastCart) handleCart(inst.lastCart);
    }

    function resolveSaleForHandle(handle) {
      if (!EXCLUDE_SALE) return;
      if (!handle) return;
      if (readSaleMap(handle)) return;
      if (SALE_PENDING[handle]) { SALE_PENDING[handle].then(recountFromLastCart, recountFromLastCart); return; }
      SALE_PENDING[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var map = {};
          var vs = product && product.variants ? product.variants : [];
          for (var i = 0; i < vs.length; i++) {
            var v = vs[i];
            var cap = v.compare_at_price;
            map[String(v.id)] = cap != null && cap > v.price;
          }
          writeSaleMap(handle, map);
        })
        .catch(function () {
          /* Blad sieci: zapamietujemy pusta mape TYLKO w pamieci, zeby nie zapetlic
             prob; sessionStorage zostaje czysty, wiec kolejna sesja sprobuje ponownie. */
          SALE_CACHE[handle] = {};
        })
        .finally(function () {
          delete SALE_PENDING[handle];
          recountFromLastCart();
        });
    }

    /* Kolejnosc: SALE_IDS (natychmiastowy pozytyw) -> cache uchwytu (rozstrzygajacy)
       -> false + start asynchronicznego rozwiazania dla tego uchwytu. */
    function isLineOnSale(item) {
      var vid = String(item.variant_id);
      if (SALE_IDS[vid]) return true;
      if (!EXCLUDE_SALE) return false;
      var handle = item.handle;
      if (!handle) return false;
      if (!anyHandleMatches(handle)) return false;
      var map = readSaleMap(handle);
      if (map) return !!map[vid];
      resolveSaleForHandle(handle);
      unresolved = true;
      return false;
    }

    /* BOGO idle gdy brak wzorcow (kolekcja + uchwyty puste) -> nic nie liczymy. */
    if (!PATTERNS.length) return;

    var pillsBuy, pillsGet, labelBuyEl, labelGetEl, earnedEl, earnedCount, confettiEl, trophyEl;
    var ctaEl = root.querySelector('[data-promo-cta]');
    pillsBuy    = root.querySelector('[data-promo-pills-buy]');
    pillsGet    = root.querySelector('[data-promo-pills-get]');
    labelBuyEl  = root.querySelector('[data-promo-label-buy]');
    labelGetEl  = root.querySelector('[data-promo-label-get]');
    earnedEl    = root.querySelector('[data-promo-earned]');
    earnedCount = root.querySelector('[data-promo-earned-count]');
    confettiEl  = root.querySelector('[data-promo-confetti]');
    trophyEl    = root.querySelector('[data-promo-gift-trophy]');
    if (!pillsBuy || !pillsGet || !labelBuyEl || !labelGetEl) return;

    /* Stan poczatkowy = to, co policzyl Liquid (sygnatura X|G; brak przeliczenia, gdy /cart.js da to samo). */
    var last = null, sig = null;
    var x0 = parseInt(cfg.x0, 10), g0 = parseInt(cfg.g0, 10);
    if (!isNaN(x0)) { last = compute(cfg, x0, isNaN(g0) ? 0 : g0); sig = last.x + '|' + last.g; }

    function fireConfetti() {
      if (!confettiEl) return;
      var pieces = confettiEl.querySelectorAll('.ppromo__confetti-piece');
      pieces.forEach(function (piece, i) {
        var angle = (Math.PI * 2 * i / pieces.length) + (Math.random() * 0.5);
        var distance = 50 + Math.random() * 50;
        var dx = Math.cos(angle) * distance;
        var dy = Math.sin(angle) * distance - 30;
        piece.style.setProperty('--ppromo-confetti-end', 'translate(' + dx + 'px, ' + dy + 'px)');
        piece.style.animationDelay = (Math.random() * 0.15) + 's';
      });
      confettiEl.classList.remove('ppromo__confetti--active');
      void confettiEl.offsetWidth;
      confettiEl.classList.add('ppromo__confetti--active');
      setTimeout(function () { confettiEl.classList.remove('ppromo__confetti--active'); }, 1500);
    }

    function celebrateGetGroup() {
      var getGroup = pillsGet ? pillsGet.closest('.ppromo__group') : null;
      if (!getGroup) return;
      getGroup.classList.remove('ppromo__group--celebrating');
      void getGroup.offsetWidth;
      getGroup.classList.add('ppromo__group--celebrating');
      setTimeout(function () { getGroup.classList.remove('ppromo__group--celebrating'); }, 700);
    }

    function fireTrophy() {
      if (!trophyEl) return;
      trophyEl.classList.remove('ppromo__gift-trophy--active');
      void trophyEl.offsetWidth;
      trophyEl.classList.add('ppromo__gift-trophy--active');
      setTimeout(function () { trophyEl.classList.remove('ppromo__gift-trophy--active'); }, 1600);
    }

    function playGiftEarnedSequence(r, callback) {
      var buyPills = pillsBuy.querySelectorAll('.ppromo__pill');
      buyPills.forEach(function (p) {
        p.classList.add('ppromo__pill--filled');
        p.classList.remove('ppromo__pill--pulse', 'ppromo__pill--just-filled');
      });
      var getPill = pillsGet.querySelector('.ppromo__pill');
      if (getPill) {
        getPill.classList.remove('ppromo__pill--pulse');
        getPill.classList.add('ppromo__pill--filled', 'ppromo__pill--just-gifted');
      }
      if (earnedEl && earnedCount) {
        earnedCount.textContent = r.gifts;
        earnedEl.classList.remove('ppromo__earned--hidden');
      }
      var lab = renderLabels(cfg, r, 'just_earned');
      labelBuyEl.innerHTML = lab.buy;
      labelGetEl.innerHTML = lab.get;
      if (ctaEl) {
        ctaEl.classList.add('ppromo__cta--hidden');
        ctaEl.classList.remove('ppromo__cta--bounce');
      }
      fireTrophy();
      fireConfetti();
      celebrateGetGroup();
      setTimeout(function () {
        if (getPill) { getPill.classList.remove('ppromo__pill--just-gifted'); }
        callback();
      }, 1500);
    }

    function applyState(r) {
      var s = r.x + '|' + r.g;
      if (s === sig) return;
      var prev = last;
      sig = s; last = r;
      if (prev && r.gifts > prev.gifts) {
        /* po sekwencji renderuj TYLKO, jesli w miedzyczasie nie przyszedl nowszy stan */
        playGiftEarnedSequence(r, function () { if (last === r) render(r, prev, true); });
        return;
      }
      render(r, prev, false);
    }

    function render(r, prev, skipCelebration) {
      var st = r.state;
      if (earnedEl && earnedCount) {
        earnedCount.textContent = r.gifts;
        earnedEl.classList.toggle('ppromo__earned--hidden', r.gifts === 0);
      }
      var buyPills = pillsBuy.querySelectorAll('.ppromo__pill');
      buyPills.forEach(function (p, i) {
        var filled = i < Math.min(r.items, BUY_QTY);
        var wasFilled = p.classList.contains('ppromo__pill--filled');
        p.classList.toggle('ppromo__pill--filled', filled);
        p.classList.remove('ppromo__pill--pulse');
        if (filled && !wasFilled && !skipCelebration) {
          p.classList.remove('ppromo__pill--just-filled');
          void p.offsetWidth;
          p.classList.add('ppromo__pill--just-filled');
          setTimeout(function (el) {
            return function () { el.classList.remove('ppromo__pill--just-filled'); };
          }(p), 850);
        }
      });
      var getPill = pillsGet.querySelector('.ppromo__pill');
      if (getPill) {
        getPill.classList.remove('ppromo__pill--just-gifted');
        getPill.classList.toggle('ppromo__pill--filled', st === 'success' || st === 'limit');
        getPill.classList.toggle('ppromo__pill--pulse', st === 'near' || st === 'gift_missing');
      }
      var lab = renderLabels(cfg, r);
      labelBuyEl.innerHTML = lab.buy;
      labelGetEl.innerHTML = lab.get;
      root.dataset.state = st;

      var ctaShouldShow = (st === 'near' || st === 'gift_missing');
      if (ctaEl) {
        var wasHidden = ctaEl.classList.contains('ppromo__cta--hidden');
        ctaEl.classList.toggle('ppromo__cta--hidden', !ctaShouldShow);
        if (wasHidden && ctaShouldShow) {
          ctaEl.classList.remove('ppromo__cta--bounce');
          void ctaEl.offsetWidth;
          ctaEl.classList.add('ppromo__cta--bounce');
          setTimeout(function () { ctaEl.classList.remove('ppromo__cta--bounce'); }, 600);
        }
      }
      if (!skipCelebration && prev) {
        var wasReady = (prev.state === 'near' || prev.state === 'gift_missing');
        if (ctaShouldShow && !wasReady) {
          fireConfetti();
          celebrateGetGroup();
        }
      }
    }

    function handleCart(cart) {
      /* Ostatni znany koszyk - przeliczenie po rozwiazaniu przecen idzie z tych
         danych, bez dodatkowego zapytania /cart.js. */
      inst.lastCart = cart;
      unresolved = false;
      var c = countLines(cfg, cart, isLineOnSale);
      if (unresolved) return; /* resolver po pobraniu wywola recountFromLastCart() */
      applyState(compute(cfg, c.x, c.g));
    }

    /* === Debounce + kolejkowanie === */
    var pending = false, queued = false, debounceTimer = null;
    function refresh() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doFetch, 250);
    }
    function doFetch() {
      if (pending) { queued = true; return; }
      pending = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { handleCart(cart); })
        .catch(function () {})
        .finally(function () {
          pending = false;
          if (queued) { queued = false; refresh(); }
        });
    }
    inst.refresh = refresh;

    var ac = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var opts = ac ? { passive: true, signal: ac.signal } : { passive: true };

    /* A1: podstawowe wykrywanie zmian koszyka przez pub/sub motywu + zdarzenia DOM */
    if (window.eventBus && typeof window.eventBus.on === 'function') {
      window.eventBus.on('update:cart:drawer', refresh);
      window.eventBus.on('update:cart', refresh);
      window.eventBus.on('cart:updated', refresh);
      window.eventBus.on('cart:added', refresh);
    }
    document.addEventListener('cart:updated', refresh, opts);
    document.addEventListener('cart:refresh', refresh, opts);
    document.addEventListener('cart:added', refresh, opts);
    document.addEventListener('cart:item-removed', refresh, opts);
    document.addEventListener('cart:item-updated', refresh, opts);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    }, opts);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    }, opts);

    inst.cleanup = function () {
      if (debounceTimer) clearTimeout(debounceTimer);
      if (window.eventBus && typeof window.eventBus.off === 'function') {
        window.eventBus.off('update:cart:drawer', refresh);
        window.eventBus.off('update:cart', refresh);
        window.eventBus.off('cart:updated', refresh);
        window.eventBus.off('cart:added', refresh);
      }
      if (ac) ac.abort();
      inst.refresh = null;
      inst.lastCart = null;
    };
  }

  /* ============ MODAL (wspolny) ============ */
  function buildModal(sectionId, contentHTML) {
    var overlay = document.createElement('div');
    overlay.className = 'ppromo-modal-' + sectionId + '-overlay';
    overlay.setAttribute('role', 'presentation');
    var modal = document.createElement('div');
    modal.className = 'ppromo-modal-' + sectionId;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Szczegoly promocji');
    var closeBtn = document.createElement('button');
    closeBtn.className = 'ppromo-modal-' + sectionId + '__close';
    closeBtn.setAttribute('type', 'button');
    closeBtn.setAttribute('aria-label', 'Zamknij');
    closeBtn.setAttribute('data-ppromo-close', '');
    closeBtn.innerHTML = '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var content = document.createElement('div');
    content.className = 'ppromo-modal-' + sectionId + '__content';
    content.innerHTML = contentHTML;
    modal.appendChild(closeBtn);
    modal.appendChild(content);
    overlay.appendChild(modal);
    return overlay;
  }

  function getModalHTML(trigger) {
    var holder = trigger.parentElement;
    var tpl = holder && holder.querySelector('[data-ppromo-modal-content]');
    if (tpl) return tpl.innerHTML;
    var span = trigger.querySelector('.ppromo__tooltip');
    return span ? span.innerHTML : null;
  }

  function closeModal() {
    var overlay = NS.modalOverlay;
    if (!overlay) return;
    overlay.removeAttribute('data-open');
    document.body.classList.remove('ppromo-modal-open');
    setTimeout(function () {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      if (NS.modalOverlay === overlay) NS.modalOverlay = null;
      if (NS.currentTrigger) {
        NS.currentTrigger.focus();
        NS.currentTrigger = null;
      }
    }, 200);
  }

  function openModal(trigger) {
    if (NS.modalOverlay) closeModal();
    var contentHTML = getModalHTML(trigger);
    if (contentHTML == null) return;
    var barRoot = trigger.closest('[data-bogo-bar]');
    var sectionId = barRoot ? barRoot.dataset.sectionId : '';
    NS.currentTrigger = trigger;
    var overlay = buildModal(sectionId, contentHTML);
    NS.modalOverlay = overlay;
    document.body.appendChild(overlay);
    document.body.classList.add('ppromo-modal-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (NS.modalOverlay === overlay) overlay.setAttribute('data-open', 'true');
      });
    });
    var closeBtn = overlay.querySelector('[data-ppromo-close]');
    if (closeBtn) {
      setTimeout(function () { closeBtn.focus(); }, 50);
      closeBtn.addEventListener('click', closeModal);
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
  }

  function initModals(root) {
    if (root.dataset.modalsInit === 'true') return;
    root.dataset.modalsInit = 'true';
    var triggers = root.querySelectorAll('.ppromo__tooltip-trigger');
    triggers.forEach(function (trigger) {
      var holder = trigger.parentElement;
      var hasTpl = holder && holder.querySelector('[data-ppromo-modal-content]');
      var hasSpan = trigger.querySelector('.ppromo__tooltip');
      if (!hasTpl && !hasSpan) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModal(trigger);
      });
    });
  }

  /* ============ Init / cleanup per instancja ============ */
  /* Zwijanie paska (mobile). Domyslnie rozwiniety; stan pamietany na czas sesji. 1:1 z paska progresu. */
  function initCollapse(root) {
    var btn = root.querySelector('[data-ppromo-collapse]');
    if (!btn) return;
    if (root.dataset.collapseInit === 'true') return;
    root.dataset.collapseInit = 'true';
    var key = 'ppromoBogoCollapsed:' + (root.dataset.sectionId || '');
    function setCollapsed(v) {
      root.dataset.collapsed = v ? '1' : '0';
      btn.setAttribute('aria-expanded', v ? 'false' : 'true');
      btn.setAttribute('aria-label', v ? 'Rozwin pasek' : 'Zwin pasek');
      try { sessionStorage.setItem(key, v ? '1' : '0'); } catch (e) {}
    }
    var stored = null;
    try { stored = sessionStorage.getItem(key); } catch (e) {}
    setCollapsed(stored === '1');
    btn.addEventListener('click', function () {
      setCollapsed(root.dataset.collapsed !== '1');
    });
  }

  function initInstance(root) {
    var id = root.dataset.sectionId;
    if (!id) return;
    var inst = NS.instances[id];
    if (!inst) { inst = NS.instances[id] = { id: id }; }
    inst.root = root;
    relocate(id);
    initRotator(root, inst);
    initDynamic(root, inst);
    initModals(root);
    initCollapse(root);
    if (root.dataset.fetchFallback === 'true') installFetchFallback();
  }

  function cleanupInstance(id) {
    var inst = NS.instances[id];
    if (!inst) return;
    stopRotator(inst);
    if (inst.cleanup) inst.cleanup();
    delete NS.instances[id];
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-bogo-bar]');
    for (var i = 0; i < roots.length; i++) initInstance(roots[i]);
  }

  /* ============ Globalne wiazania (raz) ============ */
  function bindDoc() {
    if (NS.docBound) return;
    NS.docBound = true;

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && NS.modalOverlay) closeModal();
    });

    /* A3: pauza/wznowienie rotacji wg widocznosci karty */
    document.addEventListener('visibilitychange', function () {
      var ins = NS.instances;
      for (var id in ins) {
        if (!ins.hasOwnProperty(id)) continue;
        if (document.hidden) stopRotator(ins[id]);
        else startRotator(ins[id]);
      }
    });

    /* Editor: init/cleanup pojedynczej instancji */
    document.addEventListener('shopify:section:load', function (e) {
      if (!e || !e.detail) return;
      var id = e.detail.sectionId;
      setTimeout(function () {
        cleanupInstance(id);
        relocate(id);
        var root = document.querySelector('[data-bogo-bar][data-section-id="' + id + '"]');
        if (root) {
          root.dataset.modalsInit = '';
          root.dataset.dynInit = '';
          root.dataset.collapseInit = '';
          initInstance(root);
        }
      }, 50);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e || !e.detail) return;
      cleanupInstance(e.detail.sectionId);
    });
  }

  bindDoc();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambra-code-badge"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ICON_SVGS = {
    gift: '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"/></svg>',
    sparkles: '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"/></svg>',
    tag: '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"/><path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6Z"/></svg>',
    fire: '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z"/><path stroke-linecap="round" stroke-linejoin="round" d="M12 18a3.75 3.75 0 0 0 .495-7.467 5.99 5.99 0 0 0-1.925 3.546 5.974 5.974 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z"/></svg>',
    star: '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"/></svg>',
    percent: '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M9 14.25 15 8.25M9.75 9.75a.75.75 0 0 1-1.5 0 .75.75 0 0 1 1.5 0Zm5.25 4.5a.75.75 0 0 1-1.5 0 .75.75 0 0 1 1.5 0Z"/><path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>',
    discount: '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M9 14.25 15 8.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75h.008v.008H9.75V9.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm4.125 4.5h.008v.008h-.008v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/></svg>',
    heart: '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/></svg>'
  };

  var INFO_ICON =
    '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/>' +
      '<circle cx="10" cy="6" r="0.75" fill="currentColor"/>' +
      '<path d="M10 9V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';

  var CLOSE_ICON =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M6 6 18 18M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
    '</svg>';

  // ---------- Parsowanie / formatowanie ceny (PLN) ----------
  // Obsluguje "1 234,56 zl", "89,00 zl", "od 89,00 zl", nbsp/narrow-nbsp jako tysiace.
  function parsePrice(text) {
    if (text == null) return NaN;
    var t = String(text).replace(/[  ]/g, ' ');
    var m = t.match(/\d[\d .,]*\d|\d/);
    if (!m) return NaN;
    var raw = m[0].replace(/\s/g, '');
    if (raw.indexOf(',') !== -1) {
      // przecinek = separator dziesietny, kropki = tysiace
      raw = raw.replace(/\./g, '').replace(',', '.');
    } else if ((raw.match(/\./g) || []).length > 1) {
      // wiele kropek = separatory tysiecy, brak czesci dziesietnej
      raw = raw.replace(/\./g, '');
    }
    var v = parseFloat(raw);
    return isFinite(v) ? v : NaN;
  }

  function formatPrice(num) {
    var s = (Math.round(num * 100) / 100).toFixed(2);
    var parts = s.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return intPart + ',' + parts[1] + ' zł';
  }

  function extractHandle(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // Detekcja WYPRZEDAZY: tylko genuinnie widoczne markery przeceny.
  // - Flow/Basic: rodzic .product-price--sale jest ZAWSZE renderowany, a przecena
  //   jest sygnalizowana BRAKIEM klasy .hidden (compare-at span istnieje zawsze).
  // - Dossier: <s class="dcard__price-was"> renderowany tylko przy realnej przecenie.
  // - PDP: <p id="ComparePrice" class="compare-at-price"> renderowany tylko przy on_sale.
  // Bare [class*="compare"] NIE moze samo wyzwalac wyprzedazy (ukryty span compare-at
  // istnieje na kazdej karcie).
  var SALE_SEL = '.product-price--sale:not(.hidden), s, del, #ComparePrice.compare-at-price';

  // Strip-before-read: usuwamy compare/przekreslone/ukryte wezly, aby przy
  // exclude_sale=false wciaz odczytac BIEZACA (przecenowa) cene poprawnie.
  // Dodano .hidden oraz .product-price--sale.hidden, aby ukryty blok compare
  // nigdy nie przeciekl do parsowanego tekstu.
  var JUNK_SEL = '.ambra-code-badge, .ambra-promo-badge, s, del, [class*="compare"], [class*="Compare"], .price__was, .was-price, .money--compare, .compare-at-price, .price--compare-at-price, .hidden, .product-price--sale.hidden, .visually-hidden, .visuallyhidden, [hidden]';

  function detectSale(el) {
    if (!el) return false;
    if (el.matches && el.matches(SALE_SEL)) return true;
    return !!(el.querySelector && el.querySelector(SALE_SEL));
  }

  function extractPriceText(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    var junk = clone.querySelectorAll(JUNK_SEL);
    for (var i = 0; i < junk.length; i++) {
      if (junk[i].parentNode) junk[i].parentNode.removeChild(junk[i]);
    }
    return clone.textContent || '';
  }

  function isExcluded(el) {
    return !!el.closest('cart-drawer, .cart-drawer, [data-cart-drawer], .cart-drawer-wrapper, #CartDrawer, .mini-cart, predictive-search, .predictive-search, [data-predictive-search]');
  }

  /* Karta moze miec wiecej niz jeden .product-grid--price (np. nakladka na zdjeciu).
     Preferujemy kontener POZA wrapperem zdjecia - plakietka przy widocznej cenie. */
  function pickPriceContainer(card) {
    var list = card.querySelectorAll('.product-grid--price');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest('.grid-view-item-image')) return list[i];
    }
    return list.length ? list[0] : null;
  }

  // ---------- Rejestr kontrolerow + globalne hooki (raz) ----------
  var CONTROLLERS = [];

  function fireUrlChange() {
    for (var i = 0; i < CONTROLLERS.length; i++) CONTROLLERS[i].onUrl();
  }
  function scheduleUrlChange() {
    setTimeout(fireUrlChange, 100);
    setTimeout(fireUrlChange, 400);
    setTimeout(fireUrlChange, 1000);
  }
  function rescanAll() {
    for (var i = 0; i < CONTROLLERS.length; i++) CONTROLLERS[i].rescan();
  }

  // ---------- Wspoldzielony obserwator body (P2b) ----------
  // JEDEN obserwator na cala strone (guard window.__acbBodyObs), ktory po
  // debounce robi rescan KAZDEGO zarejestrowanego kontrolera. Odlaczany dopiero
  // gdy zniknie OSTATNI kontroler.
  var bodyObsDebounce = null;
  function scheduleSharedRescan() {
    if (bodyObsDebounce) clearTimeout(bodyObsDebounce);
    bodyObsDebounce = setTimeout(function () {
      bodyObsDebounce = null;
      for (var i = 0; i < CONTROLLERS.length; i++) CONTROLLERS[i].rescan();
    }, 120);
  }
  function bodyObsRelevant(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      if (!added) continue;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'PRODUCT-CARD' ||
            (n.classList && (n.classList.contains('product-card-basic') || n.classList.contains('dcard'))) ||
            (n.querySelector && (n.querySelector('product-card') || n.querySelector('.product-card-basic') || n.querySelector('.dcard')))) {
          return true;
        }
        if (n.id === 'ProductPrice' ||
            (n.classList && n.classList.contains('price-block')) ||
            (n.querySelector && (n.querySelector('#ProductPrice') || n.querySelector('.price-block') || n.querySelector('#price-wrapper-container')))) {
          return true;
        }
      }
    }
    return false;
  }
  function ensureBodyObserver() {
    if (window.__acbBodyObs || !document.body) return;
    var obs = new MutationObserver(function (mutations) {
      if (bodyObsRelevant(mutations)) scheduleSharedRescan();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    window.__acbBodyObs = obs;
  }
  function teardownBodyObserverIfLast() {
    if (CONTROLLERS.length === 0 && window.__acbBodyObs) {
      window.__acbBodyObs.disconnect();
      window.__acbBodyObs = null;
      if (bodyObsDebounce) { clearTimeout(bodyObsDebounce); bodyObsDebounce = null; }
    }
  }

  if (!window.__acbHistoryPatched) {
    window.__acbHistoryPatched = true;
    var origPush = history.pushState;
    var origReplace = history.replaceState;
    history.pushState = function () {
      var r = origPush.apply(this, arguments);
      scheduleUrlChange();
      return r;
    };
    history.replaceState = function () {
      var r = origReplace.apply(this, arguments);
      scheduleUrlChange();
      return r;
    };
    window.addEventListener('popstate', scheduleUrlChange);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) rescanAll();
    });
    document.addEventListener('shopify:section:load', function () {
      initAll();
      rescanAll();
    });
    // Teardown (P1): przy usunieciu/przeladowaniu sekcji w edytorze niszczymy
    // kontrolery, ktorych root lezy wewnatrz usuwanej sekcji, i sprzatamy
    // wspoldzielony obserwator gdy zniknie ostatni kontroler.
    document.addEventListener('shopify:section:unload', function (e) {
      for (var i = CONTROLLERS.length - 1; i >= 0; i--) {
        var c = CONTROLLERS[i];
        if (e.target && c.root && (e.target === c.root || (e.target.contains && e.target.contains(c.root)))) {
          if (typeof c.destroy === 'function') c.destroy();
          CONTROLLERS.splice(i, 1);
        }
      }
      teardownBodyObserverIfLast();
    });
  }

  // ---------- Modal (jeden na kontroler, budowany leniwie) ----------
  function createModal(html) {
    var overlay = document.createElement('div');
    overlay.className = 'acb-modal-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="acb-modal">' +
        '<button type="button" class="acb-modal__close" aria-label="Zamknij">' + CLOSE_ICON + '</button>' +
        '<div class="acb-modal__content"></div>' +
      '</div>';
    overlay.querySelector('.acb-modal__content').innerHTML = html;
    var dialog = overlay.querySelector('.acb-modal');
    var closeBtn = overlay.querySelector('.acb-modal__close');
    var lastFocus = null;

    function focusables() {
      return dialog.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
    }
    function onKey(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      } else if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) { e.preventDefault(); return; }
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    function open(trigger) {
      lastFocus = trigger || document.activeElement;
      if (!overlay.parentNode) document.body.appendChild(overlay);
      document.body.classList.add('acb-modal-open');
      requestAnimationFrame(function () { overlay.classList.add('is-open'); });
      closeBtn.focus();
      document.addEventListener('keydown', onKey, true);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('acb-modal-open');
      document.removeEventListener('keydown', onKey, true);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    closeBtn.addEventListener('click', close);
    return { open: open, close: close };
  }

  // ---------- Kontroler per konfiguracja ----------
  function initConfig(root) {
    if (root.__acbInit) return;
    root.__acbInit = true;

    var d = root.dataset;
    var patterns = (d.patterns || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!patterns.length) return;

    var cfg = {
      patterns: patterns,
      type: d.discountType === 'amount' ? 'amount' : 'percent',
      value: parseFloat(d.discountValue) || 0,
      code: (d.code || '').trim(),
      prefix: (d.prefix || '').trim(),
      excludeSale: d.excludeSale === '1',
      iconSvg: ICON_SVGS[d.icon] || '',
      iconColor: d.iconColor || '#ffffff',
      bg: d.bg || '#1a1a1a',
      color: d.color || '#ffffff',
      pad: parseFloat(d.pad),
      fs: parseFloat(d.fs),
      radius: parseFloat(d.radius),
      showColl: d.showCollection === '1',
      showProd: d.showProduct === '1',
      showSearch: d.showSearch === '1',
      shopCurrency: (d.shopCurrency || '').trim(),
      style: d.style === 'outline' || d.style === 'dashed' ? d.style : 'full',
      border: d.border || '#1a1a1a',
      vfilter: (d.variantFilter || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean)
    };
    if (isNaN(cfg.pad)) cfg.pad = 3;
    if (isNaN(cfg.radius)) cfg.radius = 4;
    if (isNaN(cfg.fs)) cfg.fs = 12;
    cfg.ph = cfg.pad * 2 + 4;

    var tpl = root.querySelector('[data-acb-modal]');
    cfg.modalHtml = tpl ? tpl.innerHTML.trim() : '';

    var handled = new WeakSet();
    var pdpObserved = new WeakSet();
    var pdpBadge = null;
    var modal = null;
    var pdpObservers = [];      // P1: refy obserwatorow PDP do teardownu
    var pdpRetryTimer = null;   // P3: pojedyncza petla retry PDP
    var pdpRetryActive = false; // P3: guard przeciw nakladajacym sie petlom

    // M3: straznik waluty. Jesli aktywna waluta presentment (Markets) jest
    // dostepna I rozni sie od waluty sklepu, BAIL (nic nie wstrzykujemy/aktualizujemy),
    // by nie pokazac zlej kwoty z sufiksem "zl". Gdy Shopify.currency niedostepne,
    // dzialamy jak dotychczas (zakladamy walute sklepu).
    function currencyOk() {
      var active = window.Shopify && Shopify.currency && Shopify.currency.active;
      if (!active) return true;
      if (!cfg.shopCurrency) return true;
      return active === cfg.shopCurrency;
    }

    function matchesPattern(handle) {
      if (!handle) return false;
      handle = handle.toLowerCase();
      for (var i = 0; i < cfg.patterns.length; i++) {
        if (handle.indexOf(cfg.patterns[i]) !== -1) return true;
      }
      return false;
    }

    function computeDiscounted(price) {
      var v;
      if (cfg.type === 'amount') v = price - cfg.value;
      else v = price * (1 - cfg.value / 100);
      if (v < 0) v = 0;
      return v;
    }

    /* Tekst plakietki rozdzielony: prefiks+kod (zwykla waga) i cena (pogrubiona). */
    function labelPrefix() {
      var label = '';
      if (cfg.prefix) label += cfg.prefix + ' ';
      if (cfg.code) label += cfg.code + ': ';
      return label;
    }

    function priceFor(price) {
      return formatPrice(computeDiscounted(price));
    }

    function openModal(trigger) {
      if (!cfg.modalHtml) return;
      if (!modal) modal = createModal(cfg.modalHtml);
      modal.open(trigger);
    }

    function makeBadge(isPDP, price) {
      var b = document.createElement('span');
      b.className = isPDP ? 'ambra-code-badge ambra-code-badge--pdp' : 'ambra-code-badge';
      if (cfg.style === 'outline') b.classList.add('ambra-code-badge--outline');
      else if (cfg.style === 'dashed') b.classList.add('ambra-code-badge--dashed');
      b.setAttribute('data-ambra-code-badge', '');
      b.style.setProperty('--acb-bg', cfg.bg);
      b.style.setProperty('--acb-color', cfg.color);
      b.style.setProperty('--acb-pv', cfg.pad + 'px');
      b.style.setProperty('--acb-ph', cfg.ph + 'px');
      b.style.setProperty('--acb-fs', cfg.fs + 'px');
      b.style.setProperty('--acb-radius', cfg.radius + 'px');
      b.style.setProperty('--acb-icon-color', cfg.iconColor);
      b.style.setProperty('--acb-border', cfg.border);

      if (cfg.iconSvg) {
        var pi = document.createElement('span');
        pi.className = 'ambra-code-badge__promo-icon';
        pi.setAttribute('aria-hidden', 'true');
        pi.innerHTML = cfg.iconSvg;
        b.appendChild(pi);
      }

      var t = document.createElement('span');
      t.className = 'ambra-code-badge__text';
      t.textContent = labelPrefix();
      b.appendChild(t);

      var p = document.createElement('span');
      p.className = 'ambra-code-badge__price';
      p.textContent = priceFor(price);
      b.appendChild(p);

      var badge = { el: b, textEl: t, priceEl: p };

      if (cfg.modalHtml) {
        b.classList.add('ambra-code-badge--clickable');
        b.setAttribute('role', 'button');
        b.setAttribute('tabindex', '0');
        b.setAttribute('aria-label', 'Pokaż szczegóły promocji z kodem ' + cfg.code);
        var ic = document.createElement('span');
        ic.className = 'ambra-code-badge__icon';
        ic.setAttribute('aria-hidden', 'true');
        ic.innerHTML = INFO_ICON;
        b.appendChild(ic);
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openModal(b);
        });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openModal(b);
          }
        });
      }
      return badge;
    }

    // H2: pisz TYLKO gdy string faktycznie sie zmienil, aby nie retriggerowac
    // MutationObservera PDP (petla childList/characterData -> nieskonczony loop).
    function setBadgePrice(badge, price) {
      var s = priceFor(price);
      if (badge.priceEl.textContent !== s) badge.priceEl.textContent = s;
    }

    // ---------- FEATURE: filtr wariantow (variant_filter) ----------
    function matchesVFilter(vals) {
      for (var i = 0; i < vals.length; i++) {
        var v = vals[i];
        for (var j = 0; j < cfg.vfilter.length; j++) {
          if (v.indexOf(cfg.vfilter[j]) !== -1) return true;
        }
      }
      return false;
    }

    function pushVal(out, s) {
      if (s == null) return;
      s = String(s).trim().toLowerCase();
      if (s) out.push(s);
    }

    // PDP: zbiera wartosci AKTUALNIE wybranego wariantu z realnego markupu motywu.
    // Swatche  -> input[data-product-variant]:checked (value) + .swatch-element.active[data-value].
    // Dropdowny-> [data-selected-option] (biezaca wartosc) + .dropdown-list--item.selected[data-option-value].
    // Zakres ograniczony do <product-information> (kontener formularza PDP), z fallbackiem do document.
    function pdpSelectedValues(wrapper) {
      var scope = (wrapper.closest && wrapper.closest('product-information')) || document;
      var out = [];
      var checked = scope.querySelectorAll('input[data-product-variant]:checked');
      for (var i = 0; i < checked.length; i++) pushVal(out, checked[i].value);
      var actSw = scope.querySelectorAll('.swatch-element.active, .variant-swatch.active');
      for (var s = 0; s < actSw.length; s++) pushVal(out, actSw[s].getAttribute('data-value'));
      var selOpt = scope.querySelectorAll('[data-selected-option]');
      for (var o = 0; o < selOpt.length; o++) pushVal(out, selOpt[o].textContent);
      var selLi = scope.querySelectorAll('.dropdown-list--item.selected, .dropdown-list--item[selected]');
      for (var l = 0; l < selLi.length; l++) pushVal(out, selLi[l].getAttribute('data-option-value') || selLi[l].textContent);
      var vt = scope.querySelectorAll('[data-variant-title], [data-selected-variant]');
      for (var t = 0; t < vt.length; t++) pushVal(out, vt[t].getAttribute('data-variant-title') || vt[t].textContent);
      return out;
    }

    function pdpVariantOk(wrapper) {
      if (!cfg.vfilter.length) return true;
      var vals = pdpSelectedValues(wrapper);
      if (!vals.length) return true; // nie da sie ustalic wybranego wariantu -> pokazujemy (fallback)
      return matchesVFilter(vals);
    }

    // Karty listingu: wartosci wariantow sa na karcie tylko gdy motyw je eksponuje
    // (np. swatche koloru/kategorii -> [data-color-value]). Dla wariantow pojemnosci
    // karta ich NIE zawiera -> brak danych => fallback: pokazujemy dla dopasowanej kolekcji.
    function cardVariantOk(card) {
      if (!cfg.vfilter.length) return true;
      var out = [];
      var nodes = card.querySelectorAll('[data-color-value], .variant-swatch[data-value], .swatch-element[data-value], [data-option-value]');
      for (var i = 0; i < nodes.length; i++) {
        pushVal(out, nodes[i].getAttribute('data-color-value') || nodes[i].getAttribute('data-value') || nodes[i].getAttribute('data-option-value'));
      }
      if (!out.length) return true; // karta nie eksponuje wariantow -> fallback: pokaz
      return matchesVFilter(out);
    }

    // --- Karty Flow ---
    function processFlowCard(card) {
      if (handled.has(card)) return;
      if (isExcluded(card)) { handled.add(card); return; }
      var url = card.getAttribute('data-product-url') || '';
      var link = card.querySelector('a[href*="/products/"]');
      var handle = extractHandle(url) || extractHandle(link && link.getAttribute('href'));
      if (!matchesPattern(handle)) { handled.add(card); return; }
      if (!cardVariantOk(card)) { handled.add(card); return; }
      var pc = pickPriceContainer(card);
      if (!pc) return;
      if (pc.querySelector('.ambra-code-badge')) { handled.add(card); return; }
      if (cfg.excludeSale && detectSale(pc)) { handled.add(card); return; }
      var price = parsePrice(extractPriceText(pc));
      if (isNaN(price)) { handled.add(card); return; }
      pc.appendChild(makeBadge(false, price).el);
      handled.add(card);
    }

    // --- Karty basic ---
    function processBasicCard(card) {
      if (handled.has(card)) return;
      if (isExcluded(card)) { handled.add(card); return; }
      var link = card.querySelector('a[href*="/products/"]');
      var handle = extractHandle(link && link.getAttribute('href'));
      if (!matchesPattern(handle)) { handled.add(card); return; }
      if (!cardVariantOk(card)) { handled.add(card); return; }
      var pc = card.querySelector('.product-card-basic__price');
      if (!pc) return;
      if (pc.querySelector('.ambra-code-badge')) { handled.add(card); return; }
      if (cfg.excludeSale && detectSale(pc)) { handled.add(card); return; }
      var price = parsePrice(extractPriceText(pc));
      if (isNaN(price)) { handled.add(card); return; }
      pc.appendChild(makeBadge(false, price).el);
      handled.add(card);
    }

    // --- Karty Dossier ---
    function processDossierCard(card) {
      if (handled.has(card)) return;
      if (isExcluded(card)) { handled.add(card); return; }
      var handle = card.getAttribute('data-product-handle') || '';
      if (!handle) {
        var link = card.querySelector('a[href*="/products/"]');
        handle = extractHandle(link && link.getAttribute('href')) || '';
      }
      if (!matchesPattern(handle)) { handled.add(card); return; }
      if (!cardVariantOk(card)) { handled.add(card); return; }
      var pc = card.querySelector('.dcard__prices');
      if (!pc) return;
      if (pc.querySelector('.ambra-code-badge')) { handled.add(card); return; }
      if (cfg.excludeSale && detectSale(pc)) { handled.add(card); return; }
      var priceEl = pc.querySelector('.dcard__price') || pc;
      var price = parsePrice(extractPriceText(priceEl));
      if (isNaN(price)) { handled.add(card); return; }
      var badge = makeBadge(false, price).el;
      if (priceEl !== pc) priceEl.insertAdjacentElement('afterend', badge);
      else pc.appendChild(badge);
      handled.add(card);
    }

    // --- PDP: czyta i AKTUALIZUJE cene przy zmianie wariantu ---
    function updatePdp(wrapper) {
      if (!currencyOk()) return true; // M3: zla waluta -> nic nie rob
      if (pdpBadge && !document.body.contains(pdpBadge.el)) pdpBadge = null;
      var priceEl = wrapper.querySelector('#ProductPrice, [data-product-price], [data-price-text]');
      if (!priceEl) return false;
      var onSale = detectSale(wrapper);
      var price = parsePrice(extractPriceText(priceEl));
      // FEATURE variant_filter: honorujemy AKTUALNIE wybrany wariant. Gdy nie pasuje
      // -> nie tworzymy / ukrywamy badge; gdy znow pasuje -> pokazujemy + przeliczamy.
      var vok = pdpVariantOk(wrapper);

      if (!pdpBadge) {
        if (cfg.excludeSale && onSale) return true;
        if (!vok) return true;
        if (isNaN(price)) return false;
        if (priceEl.parentElement && priceEl.parentElement.querySelector('.ambra-code-badge--pdp')) return true;
        pdpBadge = makeBadge(true, price);
        /* Wiersz-wrapper: na desktopie display:contents (badge inline przy cenie,
           jak dotad), na mobile staje sie pelnym wierszem -> badge POD cena. */
        var pdpRow = document.createElement('div');
        pdpRow.className = 'acb-pdp-row';
        pdpRow.appendChild(pdpBadge.el);
        priceEl.insertAdjacentElement('afterend', pdpRow);
        pdpBadge.row = pdpRow;
        return true;
      }

      // H2: pisz display TYLKO przy realnej zmianie, by unchanged display nie
      // wywolal mutacji (a przez to kolejnego przebiegu obserwatora).
      var pdpBox = pdpBadge.row || pdpBadge.el;
      if (isNaN(price) || (cfg.excludeSale && onSale) || !vok) {
        if (pdpBox.style.display !== 'none') pdpBox.style.display = 'none';
        return true;
      }
      if (pdpBox.style.display !== '') pdpBox.style.display = '';
      setBadgePrice(pdpBadge, price);
      return true;
    }

    function processPDP() {
      if (!cfg.showProd) return;
      var m = (window.location.pathname || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      if (!matchesPattern(m[1])) return;
      var priceBlock = document.querySelector('.price-block, #price-wrapper-container');
      if (!priceBlock) return;
      if (priceBlock.closest('product-card, .product-card-basic, .related-match, .product-recommendations')) return;
      var wrapper = document.querySelector('#price-wrapper-container') || priceBlock;

      var ok = updatePdp(wrapper);
      // P3: tylko JEDNA petla retry naraz (flaga czyszczona przy sukcesie/wyczerpaniu).
      if (!ok && !pdpRetryActive) {
        pdpRetryActive = true;
        var attempts = 0;
        pdpRetryTimer = setInterval(function () {
          attempts++;
          if (updatePdp(wrapper) || attempts >= 6) {
            clearInterval(pdpRetryTimer);
            pdpRetryTimer = null;
            pdpRetryActive = false;
          }
        }, 350);
      }

      if (!pdpObserved.has(wrapper)) {
        pdpObserved.add(wrapper);
        var timer = null;
        var obs = new MutationObserver(function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () { updatePdp(wrapper); }, 120);
        });
        obs.observe(wrapper, { childList: true, subtree: true, characterData: true });
        pdpObservers.push(obs); // P1: retencja refu do teardownu
      }
    }

    function scan() {
      if (!currencyOk()) return; // M3: zla waluta presentment -> nic nie badge'ujemy
      var searchPage = /\/search\b/.test(window.location.pathname);
      var cardsOk = searchPage ? cfg.showSearch : cfg.showColl;
      if (cardsOk) {
        document.querySelectorAll('product-card[data-product-url]').forEach(processFlowCard);
        document.querySelectorAll('.product-card-basic').forEach(processBasicCard);
        document.querySelectorAll('.dcard[data-product-handle]').forEach(processDossierCard);
      }
      processPDP();
    }

    var rescanTimer = null;
    function scheduleRescan() {
      if (rescanTimer) clearTimeout(rescanTimer);
      rescanTimer = setTimeout(scan, 120);
    }

    // Obserwator body: JEDEN wspoldzielony na cala strone (P2b). Jego debounced
    // callback robi rescan KAZDEGO zarejestrowanego kontrolera. Tani pre-filtr
    // (tylko istotne addedNodes) i debounce 120ms zdefiniowane w scope modulu.
    ensureBodyObserver();

    CONTROLLERS.push({
      root: root,
      rescan: scheduleRescan,
      onUrl: function () {
        pdpBadge = null;
        scheduleRescan();
      },
      // P1: teardown tego kontrolera (obserwatory PDP + timery). Wspoldzielony
      // obserwator body jest odlaczany osobno, gdy zniknie ostatni kontroler.
      destroy: function () {
        if (rescanTimer) { clearTimeout(rescanTimer); rescanTimer = null; }
        if (pdpRetryTimer) { clearInterval(pdpRetryTimer); pdpRetryTimer = null; }
        pdpRetryActive = false;
        for (var k = 0; k < pdpObservers.length; k++) {
          try { pdpObservers[k].disconnect(); } catch (err) {}
        }
        pdpObservers.length = 0;
        root.__acbInit = false;
        /* Usun wstrzykniete plakietki, by po zmianie ustawien w edytorze
           (section:unload -> load) nowy kontroler odtworzyl je ze swiezym
           stylem/kolorami. Na storefroncie destroy nie jest wywolywany. */
        var old = document.querySelectorAll('.ambra-code-badge, .acb-pdp-row');
        for (var m = 0; m < old.length; m++) {
          if (old[m].parentNode) old[m].parentNode.removeChild(old[m]);
        }
        pdpBadge = null;
      }
    });

    scan();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-ambra-code-badge-config]');
    for (var i = 0; i < roots.length; i++) initConfig(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambra-progress-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Wspolny rejestr instancji PROGRES (klucz = section id). Ten bundle laduje sie RAZ,
     wiec sami inicjalizujemy KAZDY [data-progress-bar] na stronie (multi-instance safe).
     Osobny namespace __asbProg -> koegzystuje z sekcja BOGO (__asbBogo). */
  var NS = window.__asbProg = window.__asbProg || {
    instances: {},
    docBound: false,
    fetchPatched: false,
    modalOverlay: null,
    currentTrigger: null,
    saleCache: {},
    salePending: {}
  };
  /* Cache przecen wspoldzielony przez wszystkie instancje progresu na stronie
     (klucz = uchwyt produktu -> mapa variantId => onSale). */
  if (!NS.saleCache) NS.saleCache = {};
  if (!NS.salePending) NS.salePending = {};
  var isDesignMode = window.Shopify && window.Shopify.designMode;

  /* ============ RELOKACJA do sticky headera ============ */
  function relocate(sectionId) {
    if (isDesignMode) return;
    var section = document.getElementById('shopify-section-' + sectionId);
    var headerWrapper = document.querySelector('.header-section--wrapper');
    if (!section || !headerWrapper) return;
    if (section.parentElement === headerWrapper) return;
    headerWrapper.insertBefore(section, headerWrapper.firstChild);
  }

  /* ============ Wykrywanie mutacji koszyka (wspolne) ============ */
  function isCartMutation(url, method) {
    var m = String(method || 'GET').toUpperCase();
    return /\/cart(\/|\?|$|\.js)/i.test(url) && !(m === 'GET' && /\/cart\.js(\?|$)/i.test(url));
  }
  function refreshAll() {
    var ins = NS.instances;
    for (var id in ins) {
      if (ins.hasOwnProperty(id) && ins[id].refresh) ins[id].refresh();
    }
  }
  /* A1: MINIMALNY, opcjonalny wrapper TYLKO na fetch (bez XHR), instalowany raz. */
  function installFetchFallback() {
    if (NS.fetchPatched || !window.fetch) return;
    NS.fetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = ''; var method = 'GET';
      try {
        if (typeof args[0] === 'string') url = args[0];
        else if (args[0]) { url = args[0].url || String(args[0]); method = args[0].method || 'GET'; }
        if (args[1] && args[1].method) method = args[1].method;
      } catch (e) {}
      var p = origFetch.apply(this, args);
      if (isCartMutation(url, method)) {
        p.then(function () { refreshAll(); }).catch(function () {});
      }
      return p;
    };
  }

  /* ============ SILNIK DYNAMICZNY (per instancja) ============ */
  function initDynamic(root, inst) {
    if (root.dataset.runDynamic !== 'true') return;
    if (root.dataset.dynInit === 'true') return;
    root.dataset.dynInit = 'true';

    var PROGRESS_STYLE = root.dataset.progressStyle || 'pills';
    var EMPTY_TEXT_PROGRESS = root.dataset.emptyTextProgress || '';
    var DONE_TEXT = root.dataset.doneText || '';
    var SHOP_CURRENCY = root.dataset.shopCurrency || '';
    /* basis: 'cart' = caly koszyk (cart.total_price); 'eligible' = kolekcja/uchwyty/wariant bez przecen
       (original_line_price); 'cart_if_eligible' = caly koszyk, ale 0 dopoki nie ma linii eligible. */
    function basisOf(v) { return (v === 'cart' || v === 'cart_if_eligible') ? v : 'eligible'; }
    function famOf(b) { return b === 'eligible' ? 'eligible' : 'cart'; }
    var TIERS = [
      { amt: parseInt(root.dataset.t1, 10) || 0, label: root.dataset.t1Label || '', basis: basisOf(root.dataset.t1Basis) },
      { amt: parseInt(root.dataset.t2, 10) || 0, label: root.dataset.t2Label || '', basis: basisOf(root.dataset.t2Basis) },
      { amt: parseInt(root.dataset.t3, 10) || 0, label: root.dataset.t3Label || '', basis: basisOf(root.dataset.t3Basis) }
    ].filter(function (t) { return t.amt > 0; }).sort(function (a, b) { return a.amt - b.amt; });
    var BASIS_HINT = root.dataset.basisHint || '';
    var REQUIRED_TEXT = root.dataset.requiredText || '';

    /* === Multi-collection / wariant / przeceny === */
    var PATTERNS = (root.dataset.handlePatterns || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var VFILTER = (root.dataset.variantFilter || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var EXCLUDE_SALE = root.dataset.excludeSale === 'true';

    /* /cart.js line items NIE maja compare_at_price, wiec dopasowujemy po variant_id
       wg listy wariantow w przecenie renderowanej server-side (kolekcja + koszyk). */
    var SALE_IDS = {}; (root.dataset.saleVariants||'').split(',').forEach(function(x){ if(x) SALE_IDS[x]=1; });

    function handleMatches(h) {
      h = (h || '').toLowerCase();
      for (var i = 0; i < PATTERNS.length; i++) {
        if (PATTERNS[i] && h.indexOf(PATTERNS[i]) !== -1) return true;
      }
      return false;
    }
    function variantMatches(item){ if(!VFILTER.length) return true; var h=(item.variant_title||''); if(item.options_with_values){for(var i=0;i<item.options_with_values.length;i++){h+=' '+item.options_with_values[i].value;}} h=h.toLowerCase(); for(var j=0;j<VFILTER.length;j++){ if(VFILTER[j] && h.indexOf(VFILTER[j])!==-1) return true;} return false; }

    /* Zakres paska wg uchwytow: puste wzorce = caly koszyk (jak w eligibleSubtotal). */
    function handleInScope(h) {
      if (!PATTERNS.length) return true;
      return handleMatches(h);
    }

    /* ===== AUTORYTATYWNE rozpoznawanie przecen (per wariant) =====
       SALE_IDS to tylko snapshot z renderu: kolekcje sa w Liquid obciete do 50
       produktow, a pozycja dodana przez AJAX juz po renderze w ogole tam nie trafia.
       Dlatego dla uchwytow objetych paskiem dociagamy rekord produktu RAZ na uchwyt
       i zapamietujemy mape variantId => onSale (pamiec + sessionStorage).
       Do czasu rozwiazania linia jest traktowana jako NIE-przeceniona (liczy sie),
       zeby nie migotal normalny scenariusz; po rozwiazaniu robimy jeden przelicz. */
    var SALE_CACHE = NS.saleCache;
    var SALE_PENDING = NS.salePending;
    var SALE_SS_PREFIX = 'ambraSale:';

    function readSaleMap(handle) {
      if (SALE_CACHE[handle]) return SALE_CACHE[handle];
      try {
        var raw = window.sessionStorage.getItem(SALE_SS_PREFIX + handle);
        if (raw) {
          var parsed = JSON.parse(raw);
          if (parsed && typeof parsed === 'object') {
            SALE_CACHE[handle] = parsed;
            return parsed;
          }
        }
      } catch (e) {}
      return null;
    }

    function writeSaleMap(handle, map) {
      SALE_CACHE[handle] = map;
      try {
        window.sessionStorage.setItem(SALE_SS_PREFIX + handle, JSON.stringify(map));
      } catch (e) {}
    }

    function recountFromLastCart() {
      if (inst.lastCart) handleCart(inst.lastCart);
    }

    function resolveSaleForHandle(handle) {
      if (!EXCLUDE_SALE) return;
      if (!handle) return;
      if (readSaleMap(handle)) return;
      if (SALE_PENDING[handle]) {
        /* Inna instancja juz pobiera ten uchwyt - dopinamy wlasny przelicz po zakonczeniu. */
        SALE_PENDING[handle].then(recountFromLastCart, recountFromLastCart);
        return;
      }
      SALE_PENDING[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          var map = {};
          var vs = product && product.variants ? product.variants : [];
          for (var i = 0; i < vs.length; i++) {
            var v = vs[i];
            var cap = v.compare_at_price;
            map[String(v.id)] = cap != null && cap > v.price;
          }
          writeSaleMap(handle, map);
        })
        .catch(function () {
          /* Blad sieci: zapamietujemy pusta mape TYLKO w pamieci, zeby nie zapetlic
             prob; sessionStorage zostaje czysty, wiec kolejna sesja sprobuje ponownie. */
          SALE_CACHE[handle] = {};
        })
        .finally(function () {
          delete SALE_PENDING[handle];
          recountFromLastCart();
        });
    }

    /* Kolejnosc: SALE_IDS (natychmiastowy pozytyw) -> cache uchwytu (rozstrzygajacy)
       -> false + start asynchronicznego rozwiazania dla tego uchwytu. */
    function isLineOnSale(item) {
      var vid = String(item.variant_id);
      if (SALE_IDS[vid]) return true;
      if (!EXCLUDE_SALE) return false;
      var handle = item.handle;
      if (!handle) return false;
      if (!handleInScope(handle)) return false;
      var map = readSaleMap(handle);
      if (map) return !!map[vid];
      resolveSaleForHandle(handle);
      return false;
    }

    /* Klucz ostatniego stanu: podstawa 'eligible' + podstawa 'cart' + pusty koszyk.
       Startuje ze snapshotu renderu, zeby pierwszy /cart.js bez zmian nie migal. */
    var lastKey = (root.dataset.initialTotal || '') + ':' + (root.dataset.initialCartTotal || '') + ':' + (root.dataset.initialCartOriginal || '') + ':' + (root.dataset.initialEmpty || '');

    function esc(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    /* B4(b): kwoty zawsze z dwoma miejscami: "X,XX zl" */
    function fmt(gr) {
      var zl = Math.floor(gr / 100);
      var g = Math.round(gr % 100);
      return zl + ',' + (g < 10 ? '0' : '') + g + ' zł';
    }

    var progMsgEl = root.querySelector('[data-ppromo-progress-msg]');
    if (!progMsgEl) return;
    var ctaEl = root.querySelector('[data-promo-cta]');

    /* === Eligible subtotal (grosze) === */
    function eligibleSubtotal(cart) {
      if (!cart || !Array.isArray(cart.items)) return 0;
      var s = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        /* NADRZEDNA bramka przecen - sprawdzana PRZED uchwytem i wariantem.
           Przy exclude_sale ON linia w przecenie nie wchodzi do sumy NIGDY,
           niezaleznie od tego czy i jaki filtr wariantu jest ustawiony. */
        if (EXCLUDE_SALE && isLineOnSale(it)) continue;
        var inc = !PATTERNS.length || handleMatches(it.handle);
        if (!inc) continue;
        if (!variantMatches(it)) continue;
        /* Ceny PRZED rabatami - kod wpisany w koszyku nie cofa progu, ktory odblokowal. */
        s += it.original_line_price || 0;
      }
      return s;
    }

    /* === Podstawa 'cart': caly koszyk po rabatach (jak Shopify liczy prog dostawy) === */
    function cartSubtotal(cart) {
      if (!cart || typeof cart.total_price !== 'number') return 0;
      return cart.total_price;
    }
    /* Caly koszyk PRZED rabatami - podstawa 'cart_if_eligible' (kod nie cofa progu o wlasny rabat). */
    function cartOriginal(cart) {
      if (!cart || typeof cart.original_total_price !== 'number') return cartSubtotal(cart);
      return cart.original_total_price;
    }
    function subFor(basis, eligGr, allGr, origGr) {
      if (basis === 'cart') return allGr;
      if (basis === 'cart_if_eligible') return eligGr > 0 ? origGr : 0;
      return eligGr;
    }
    function tierSub(tier, eligGr, allGr, origGr) {
      return subFor(tier.basis, eligGr, allGr, origGr);
    }
    function elSub(el, eligGr, allGr, origGr) {
      return subFor(basisOf(el.getAttribute('data-basis')), eligGr, allGr, origGr);
    }
    /* Start odcinka do progu i: poprzedni prog tylko przy tej samej rodzinie podstawy, inaczej 0. */
    function prevAmtFor(i) {
      if (i <= 0) return 0;
      return famOf(TIERS[i - 1].basis) === famOf(TIERS[i].basis) ? TIERS[i - 1].amt : 0;
    }

    /* === PROGRES KOSZYKA === */
    function buildProgressMessage(isEmpty, prev, next, missGr, eligGr) {
      if (isEmpty) return esc(EMPTY_TEXT_PROGRESS);
      if (!next) return esc(DONE_TEXT);
      if (next.basis === 'cart_if_eligible' && eligGr === 0 && REQUIRED_TEXT) {
        var lead = (PROGRESS_STYLE !== 'stepper' && prev) ? '&#10003; ' + esc(prev.label) + ' &middot; ' : '';
        return lead + esc(REQUIRED_TEXT) + ' <b>' + esc(next.label) + '</b>';
      }
      var hint = (next.basis === 'eligible' && BASIS_HINT) ? ' ' + esc(BASIS_HINT) : '';
      if (PROGRESS_STYLE === 'stepper') {
        return 'Brakuje <span class="ppromo__highlight">' + fmt(missGr) + '</span>' + hint + ' do <b>' + esc(next.label) + '</b>';
      }
      return (prev ? '&#10003; ' + esc(prev.label) + ' &middot; ' : '') +
        'Brakuje <span class="ppromo__highlight">' + fmt(missGr) + '</span>' + hint + ' do: ' + esc(next.label);
    }

    /* === Rail fill (mobilny stepper) - piecewise do srodkow okregow ===
       Kotwice: total=0 -> 0%; total=prog i -> srodek okregu i; total > ostatni prog -> 100%.
       Srodki okregow (space-around) = (2i+1)/(2n). Zabezpieczenie dziel-przez-zero. */
    function computeRailFill(isEmpty, eligGr, allGr, origGr) {
      var n = TIERS.length;
      if (n === 0) return 0;
      if (isEmpty) return 0;
      var prevPos = 0;
      for (var i = 0; i < n; i++) {
        var amt = TIERS[i].amt * 100;
        var pos = (2 * i + 1) / (2 * n) * 100;
        var sub = tierSub(TIERS[i], eligGr, allGr, origGr);
        if (sub < amt) {
          var prevAmt = prevAmtFor(i) * 100;
          var den = amt - prevAmt;
          if (den <= 0) return prevPos;
          var frac = (sub - prevAmt) / den;
          if (frac < 0) frac = 0;
          if (frac > 1) frac = 1;
          return prevPos + (pos - prevPos) * frac;
        }
        prevPos = pos;
      }
      return 100;
    }

    function applyProgress(cart) {
      var eligGr = eligibleSubtotal(cart);
      var allGr = cartSubtotal(cart);
      var origGr = cartOriginal(cart);
      var isEmpty = !cart || !cart.item_count;
      var key = eligGr + ':' + allGr + ':' + origGr + ':' + (isEmpty ? '1' : '0');
      if (key === lastKey) return;
      lastKey = key;

      /* Pierwszy NIEOSIAGNIETY prog (kazdy na swojej podstawie) = "next"; ostatni osiagniety = "prev". */
      var prev = null, next = null, missGr = 0;
      for (var i = 0; i < TIERS.length; i++) {
        var subI = tierSub(TIERS[i], eligGr, allGr, origGr);
        if (subI < TIERS[i].amt * 100) { next = TIERS[i]; missGr = TIERS[i].amt * 100 - subI; break; }
        prev = TIERS[i];
      }

      var html = buildProgressMessage(isEmpty, prev, next, missGr, eligGr);
      if (progMsgEl) {
        progMsgEl.classList.add('ppromo__prog-msg--updating');
        setTimeout(function () {
          progMsgEl.innerHTML = html;
          progMsgEl.classList.remove('ppromo__prog-msg--updating');
        }, 150);
      }

      var msPills = root.querySelectorAll('[data-ms-amt]');
      for (var a = 0; a < msPills.length; a++) {
        var mAmt = parseInt(msPills[a].getAttribute('data-ms-amt'), 10) || 0;
        msPills[a].classList.toggle('ppromo__ms-pill--hit', mAmt > 0 && elSub(msPills[a], eligGr, allGr, origGr) >= mAmt * 100);
      }

      /* data-seg-prev jest juz policzony server-side z uwzglednieniem podstawy (0 przy zmianie podstawy). */
      var segFills = root.querySelectorAll('[data-seg-amt]');
      for (var b = 0; b < segFills.length; b++) {
        var sAmt = parseInt(segFills[b].getAttribute('data-seg-amt'), 10) || 0;
        var sPrev = parseInt(segFills[b].getAttribute('data-seg-prev'), 10) || 0;
        var sDen = (sAmt - sPrev) * 100;
        var sW = 0;
        if (sDen > 0) {
          var sNum = elSub(segFills[b], eligGr, allGr, origGr) - sPrev * 100;
          if (sNum < 0) sNum = 0;
          sW = Math.floor(sNum * 100 / sDen);
          if (sW > 100) sW = 100;
        }
        segFills[b].style.width = sW + '%';
      }
      var segLabels = root.querySelectorAll('[data-seg-label-amt]');
      for (var c = 0; c < segLabels.length; c++) {
        var lAmt = parseInt(segLabels[c].getAttribute('data-seg-label-amt'), 10) || 0;
        segLabels[c].classList.toggle('ppromo__seg-label--hit', lAmt > 0 && elSub(segLabels[c], eligGr, allGr, origGr) >= lAmt * 100);
      }

      var steps = root.querySelectorAll('[data-step-amt]');
      for (var d = 0; d < steps.length; d++) {
        var stAmt = parseInt(steps[d].getAttribute('data-step-amt'), 10) || 0;
        steps[d].classList.toggle('ppromo__step--hit', stAmt > 0 && elSub(steps[d], eligGr, allGr, origGr) >= stAmt * 100);
      }
      var minibar = root.querySelector('[data-ppromo-minibar]');
      if (minibar) {
        var mw;
        if (!next) {
          mw = 100;
        } else {
          var nIdx = TIERS.indexOf(next);
          var mp = prevAmtFor(nIdx);
          var mDen = (next.amt - mp) * 100;
          mw = 0;
          if (mDen > 0) {
            var mNum = tierSub(next, eligGr, allGr, origGr) - mp * 100;
            if (mNum < 0) mNum = 0;
            mw = Math.floor(mNum * 100 / mDen);
            if (mw > 100) mw = 100;
          }
        }
        minibar.style.width = mw + '%';
      }
      var rail = root.querySelector('[data-ppromo-rail]');
      if (rail) {
        rail.style.width = computeRailFill(isEmpty, eligGr, allGr, origGr) + '%';
      }

      var allDone = TIERS.length > 0 && !next && !isEmpty;
      root.dataset.complete = allDone ? '1' : '0';
      if (ctaEl) {
        ctaEl.classList.toggle('ppromo__cta--hidden', !allDone);
      }
    }

    function handleCart(cart) {
      /* B1: pomijaj aktualizacje gdy waluta prezentacji != waluta sklepu (progi w PLN) */
      if (SHOP_CURRENCY && cart && cart.currency && cart.currency !== SHOP_CURRENCY) return;
      /* Ostatni znany koszyk - przeliczenie po rozwiazaniu przecen idzie z tych
         danych, bez dodatkowego zapytania /cart.js. */
      inst.lastCart = cart;
      applyProgress(cart);
    }

    /* === Debounce + kolejkowanie === */
    var pending = false, queued = false, debounceTimer = null;
    function refresh() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doFetch, 250);
    }
    function doFetch() {
      if (pending) { queued = true; return; }
      pending = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { handleCart(cart); })
        .catch(function () {})
        .finally(function () {
          pending = false;
          if (queued) { queued = false; refresh(); }
        });
    }
    inst.refresh = refresh;

    var ac = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var opts = ac ? { passive: true, signal: ac.signal } : { passive: true };

    /* A1: podstawowe wykrywanie zmian koszyka przez pub/sub motywu + zdarzenia DOM */
    if (window.eventBus && typeof window.eventBus.on === 'function') {
      window.eventBus.on('update:cart:drawer', refresh);
      window.eventBus.on('update:cart', refresh);
      window.eventBus.on('cart:updated', refresh);
      window.eventBus.on('cart:added', refresh);
    }
    document.addEventListener('cart:updated', refresh, opts);
    document.addEventListener('cart:refresh', refresh, opts);
    document.addEventListener('cart:added', refresh, opts);
    document.addEventListener('cart:item-removed', refresh, opts);
    document.addEventListener('cart:item-updated', refresh, opts);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    }, opts);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    }, opts);

    inst.cleanup = function () {
      if (debounceTimer) clearTimeout(debounceTimer);
      if (window.eventBus && typeof window.eventBus.off === 'function') {
        window.eventBus.off('update:cart:drawer', refresh);
        window.eventBus.off('update:cart', refresh);
        window.eventBus.off('cart:updated', refresh);
        window.eventBus.off('cart:added', refresh);
      }
      if (ac) ac.abort();
      inst.refresh = null;
      inst.lastCart = null;
    };
  }

  /* ============ MODAL (wspolny) ============ */
  function buildModal(sectionId, contentHTML) {
    var overlay = document.createElement('div');
    overlay.className = 'ppromo-modal-' + sectionId + '-overlay';
    overlay.setAttribute('role', 'presentation');
    var modal = document.createElement('div');
    modal.className = 'ppromo-modal-' + sectionId;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Szczegoly promocji');
    var closeBtn = document.createElement('button');
    closeBtn.className = 'ppromo-modal-' + sectionId + '__close';
    closeBtn.setAttribute('type', 'button');
    closeBtn.setAttribute('aria-label', 'Zamknij');
    closeBtn.setAttribute('data-ppromo-close', '');
    closeBtn.innerHTML = '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 1L17 17M17 1L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var content = document.createElement('div');
    content.className = 'ppromo-modal-' + sectionId + '__content';
    content.innerHTML = contentHTML;
    modal.appendChild(closeBtn);
    modal.appendChild(content);
    overlay.appendChild(modal);
    return overlay;
  }

  function getModalHTML(trigger) {
    var holder = trigger.parentElement;
    var tpl = holder && holder.querySelector('[data-ppromo-modal-content]');
    if (tpl) return tpl.innerHTML;
    var span = trigger.querySelector('.ppromo__tooltip');
    return span ? span.innerHTML : null;
  }

  function closeModal() {
    var overlay = NS.modalOverlay;
    if (!overlay) return;
    overlay.removeAttribute('data-open');
    document.body.classList.remove('ppromo-modal-open');
    setTimeout(function () {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      if (NS.modalOverlay === overlay) NS.modalOverlay = null;
      if (NS.currentTrigger) {
        NS.currentTrigger.focus();
        NS.currentTrigger = null;
      }
    }, 200);
  }

  function openModal(trigger) {
    if (NS.modalOverlay) closeModal();
    var contentHTML = getModalHTML(trigger);
    if (contentHTML == null) return;
    var barRoot = trigger.closest('[data-progress-bar]');
    var sectionId = barRoot ? barRoot.dataset.sectionId : '';
    NS.currentTrigger = trigger;
    var overlay = buildModal(sectionId, contentHTML);
    NS.modalOverlay = overlay;
    document.body.appendChild(overlay);
    document.body.classList.add('ppromo-modal-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (NS.modalOverlay === overlay) overlay.setAttribute('data-open', 'true');
      });
    });
    var closeBtn = overlay.querySelector('[data-ppromo-close]');
    if (closeBtn) {
      setTimeout(function () { closeBtn.focus(); }, 50);
      closeBtn.addEventListener('click', closeModal);
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
  }

  function initModals(root) {
    if (root.dataset.modalsInit === 'true') return;
    root.dataset.modalsInit = 'true';
    var triggers = root.querySelectorAll('.ppromo__tooltip-trigger');
    triggers.forEach(function (trigger) {
      var holder = trigger.parentElement;
      var hasTpl = holder && holder.querySelector('[data-ppromo-modal-content]');
      var hasSpan = trigger.querySelector('.ppromo__tooltip');
      if (!hasTpl && !hasSpan) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModal(trigger);
      });
    });
  }

  /* ============ Init / cleanup per instancja ============ */
  /* Zwijanie paska (mobile). Domyslnie rozwiniety; stan pamietany na czas sesji. */
  function initCollapse(root) {
    var btn = root.querySelector('[data-ppromo-collapse]');
    if (!btn) return;
    if (root.dataset.collapseInit === 'true') return;
    root.dataset.collapseInit = 'true';

    var key = 'ppromoCollapsed:' + (root.dataset.sectionId || '');

    function setCollapsed(v) {
      root.dataset.collapsed = v ? '1' : '0';
      btn.setAttribute('aria-expanded', v ? 'false' : 'true');
      btn.setAttribute('aria-label', v ? 'Rozwin pasek' : 'Zwin pasek');
      try { sessionStorage.setItem(key, v ? '1' : '0'); } catch (e) {}
    }

    var stored = null;
    try { stored = sessionStorage.getItem(key); } catch (e) {}
    setCollapsed(stored === '1');

    btn.addEventListener('click', function () {
      setCollapsed(root.dataset.collapsed !== '1');
    });
  }

  function initInstance(root) {
    var id = root.dataset.sectionId;
    if (!id) return;
    var inst = NS.instances[id];
    if (!inst) { inst = NS.instances[id] = { id: id }; }
    inst.root = root;
    relocate(id);
    initDynamic(root, inst);
    initModals(root);
    initCollapse(root);
    if (root.dataset.fetchFallback === 'true') installFetchFallback();
  }

  function cleanupInstance(id) {
    var inst = NS.instances[id];
    if (!inst) return;
    if (inst.cleanup) inst.cleanup();
    delete NS.instances[id];
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-progress-bar]');
    for (var i = 0; i < roots.length; i++) initInstance(roots[i]);
  }

  /* ============ Globalne wiazania (raz) ============ */
  function bindDoc() {
    if (NS.docBound) return;
    NS.docBound = true;

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && NS.modalOverlay) closeModal();
    });

    /* Editor: init/cleanup pojedynczej instancji */
    document.addEventListener('shopify:section:load', function (e) {
      if (!e || !e.detail) return;
      var id = e.detail.sectionId;
      setTimeout(function () {
        cleanupInstance(id);
        relocate(id);
        var root = document.querySelector('[data-progress-bar][data-section-id="' + id + '"]');
        if (root) {
          root.dataset.modalsInit = '';
          root.dataset.dynInit = '';
          initInstance(root);
        }
      }, 50);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e || !e.detail) return;
      cleanupInstance(e.detail.sectionId);
    });
  }

  bindDoc();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
